import { Service } from '@phishtool/service';
import { loggedOutContactRequestHandler } from '~server/controllers/service/users/contact-request';
import { unauthenticatedContactSalesTeamRequestHandler } from '~server/controllers/service/users/contact-sales-team';
import { recaptchaMiddleware, rateLimitMiddleware } from '~middleware';
import { UnauthenticatedContactSalesTeamRequestDataSchema, LoggedOutContactRequestDataSchema, } from '@phishtool/service-schemas';
export class UnauthenticatedUserService extends Service {
    constructor() {
        super(...arguments);
        this.useSendContactRequest = this.addSingletonNonResourceMutation({
            controller: loggedOutContactRequestHandler,
            schema: LoggedOutContactRequestDataSchema,
            middleware: [recaptchaMiddleware, rateLimitMiddleware],
            routeId: 'contact-request',
        });
        this.useContactSalesTeam = this.addSingletonNonResourceMutation({
            controller: unauthenticatedContactSalesTeamRequestHandler,
            schema: UnauthenticatedContactSalesTeamRequestDataSchema,
            middleware: [recaptchaMiddleware, rateLimitMiddleware],
            routeId: 'contact-sales-team',
        });
    }
}
